


















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Icon } from '@alpha/ink'
import { TestStatus } from '@shared/types/database'

@Component({
  components: {
    Icon
  }
})
export default class ValidatedSection extends Vue {
  @Prop({ required: true }) readonly valid!: boolean
  @Prop({ required: true }) readonly status!: TestStatus

  get hideCheck () {
    return ![TestStatus.Draft, TestStatus.InReview].includes(this.status)
  }

  get fadeCheck () {
    return this.status === TestStatus.InReview
  }
}
